<template>
	<div class="create-product">
		<v-form v-on:submit.prevent="createMinibar">
			<v-layout row wrap>
				<v-flex md12 text-xs-left>
					<p class="title-form mb-0">Elige la sucursal y habitación en la que crearás el {{ minusText }}</p>
					<span class="small">(Para poder seleccionar la habitación es necesario seleccionar una o todas las sucursales).</span>
				</v-flex>
				<v-flex md4 pt-2>
					<v-select
						class="filter-select"
						v-bind:items="subsidiaries"
						item-text="name"
						item-value="id"
						v-model="model.subsidiaryId"
						hide-details
						label="Sucursal"
						v-on:change="loadRooms"
						single-line
						bottom>
					</v-select>
				</v-flex>
				<v-flex md4 pt-2>
					<v-select
						class="filter-select ml-2"
						v-bind:items="rooms"
						item-text="codeRoom"
						item-value="codeRoom"
						v-bind:disabled="rooms.length === 0"
						v-model="model.externalCode"
						label="Todas las habitaciones"
						min-width="198"
						max-height="250"
						single-line
						required
						bottom>
					</v-select>
				</v-flex>
				<v-flex md12 pt-3>
					<p class="title-form mb-0">Detalles del {{ mayusText }}</p>
				</v-flex>
				<v-flex md6 pt-2>
					<v-text-field
						type="text"
						class="input-border-inset"
						:placeholder="`Nombre del ${minusText}`"
						required
						v-model="model.name">
					</v-text-field>
				</v-flex>
				<v-flex md6 pt-2 text-xs-left>
					<v-text-field
						type="text"
						class="input-border-inset"
						placeholder="Código"
						maxlength="10"
						required
						v-model="model.code">
					</v-text-field>
					<span class="small">Máximo 10 caracteres</span>
				</v-flex>
			</v-layout>
			<div class="actions">
				<v-btn
					type="submit"
					class="btn-save"
					:disabled="!model.name || !model.code || !model.externalCode">
					Guardar
				</v-btn>
			</div>
		</v-form>
	</div>
</template>

<script>
import mixin from '@/shared/mixins';
import minibarResource from '@/resource/warehouse';

async function created() {
	this.resource = minibarResource(this);
	const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
	this.subsidiaries = subsidiaries.data;
	if (this.minibarId) {
		this.loadData(this.minibarId);
	}
}

async function createMinibar() {
	let dataSend = null;
	if (this.model.externalCode) {
		if (!this.model.subsidiaryId) {
			this.model.subsidiaryId = this.model.subsidiaryId;
		}
		dataSend = {
			code: this.model.code,
			flagActive: this.model.flagActive,
			isMain: this.model.isMain,
			name: this.model.name,
			externalCode: this.model.externalCode,
			subsidiaryId: this.model.subsidiaryId,
		};
		const baseUrl = `${process.env.PRODUCTS_URL}/p/warehouses`;
		const url = this.minibarId ? `${baseUrl}/${this.minibarId}` : baseUrl;
		const method = this.minibarId ? 'patch' : 'post';
		const message = this.minibarId ? 'editó' : 'creó';
		await this.$http[method](url, dataSend);
		this.showNotification(`El minibar se ${message} correctamente.`, 'success');
		this.$router.push(this.listHref);
		this.$router.push(this.listHref);
	} else {
		this.showNotification('La habitación es requerida, por favor elija una', 'warning');
	}
}

async function loadData(id) {
	const response = await this.$http.get(`${process.env.PRODUCTS_URL}/p/warehouses/${id}`);
	this.model = response.data;
	this.loadRooms(this.model.subsidiaryId, this.model.externalCode);
}

async function loadRooms(subsidiaryId, externalCode) {
	this.model.externalCode = '';
	const { data: rooms } = await this.$http.get(`${process.env.PMS_URL}/roomtype/${subsidiaryId}/rooms`);
	this.rooms = rooms.data;
	if (externalCode) {
		this.model.externalCode = externalCode;
	}
}

function mayusText() {
	return (this.$route.name === 'warehouses-new') || (this.$route.name === 'warehouses-config') ?
		'Almacén' : 'Minibar';
}

function minusText() {
	return (this.$route.name === 'warehouses-new') || (this.$route.name === 'warehouses-config') ?
		'almacén' : 'minibar';
}

export default {
	components: {},
	computed: {
		mayusText,
		minusText,
	},
	created,
	data() {
		return {
			filterBySubsidiaryId: null,
			listHref: { name: 'minibar-list' },
			model: {
				code: null,
				externalCode: '',
				flagActive: true,
				isMain: false,
				name: null,
				codeRoom: '',
				subsidiaryId: 0,
			},
			resource: null,
			rooms: [],
			roomSelected: null,
		};
	},
	methods: {
		createMinibar,
		loadData,
		loadRooms,
	},
	mixins: mixin,
	name: 'minibar-new',
	props: ['minibarId'],
};
</script>

<style lang="scss" scoped>
.create-product {
	width: 610px;

	.actions {
		margin-top: 26px;
		width: 0;
	}

	.btn-primary {
		color: white;
		background-color: map-get($colors, default-skyblue);
		box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.1);
		font-family: map-get($fonts, bold);
		height: 38px;
		width: 164px;
	}

	.title-form {
		color: map-get($colors, dark);
		font-family: map-get($fonts, medium);
		font-size: map-get($colors, fourteen);
		font-weight: 500;
		line-height: 0.6;
		padding-top: 10px;
		text-align: left;
	}

	.input-form {
		background-color: white;
		box-shadow: inset 0 2px 5px 0 rgba(0, 0, 0, 0.2);
		height: 40px;
		padding-left: 10px;
		width: 100%;
	}
}

.radio-keeping {
	display: flex;
	font-size: map-get($sizes, fourteen);
}

.small {
	font-size: map-get($sizes, twelve);
}
</style>



// WEBPACK FOOTER //
// Create.vue?2ffabf68